import UtilityService from '../services/utility.service';
import DataService from '../services/data.service';
import LoginFormComponent from './login-form.component';
import FrontPageComponent from './front-page.component';

export class MainComponent {
    constructor() {
        this.componentName = "mainComponent";
        this.template = `
		<div id="loginFormComponent"></div>
		<div id="frontPageComponent"></div>
		<div id="polyatomicAnionsComponent"></div>
		<div id="solubilityRulesComponent"></div>
		<div id="solubilityQuizComponent"></div>
		<div id="solubilityQuizScoresComponent"></div>
		<div id="nomenclatureQuizComponent"></div>
		<div id="nomenclatureQuizScoresComponent"></div>
		<div id="elementsComponent"></div>
		<div id="visitorsComponent"></div>
		<div id="modalCloseComponent"></div>
	    `;
    }

    render() {
        _svc.util.html("#"+this.componentName, this.template);
        _svc.data.tokenCheck(this.show, this.hide);
    }
    
	show(data) {
		_cmp.frontPage.render();
	}
	
	hide(error) {
        _svc.data.clearData();
		_cmp.loginForm.render();
    }

    hideAll() {
		_svc.util.clear("#loginFormComponent");
		_svc.util.clear("#frontPageComponent");
		_svc.util.clear("#polyatomicAnionsComponent");
		_svc.util.clear("#solubilityRulesComponent");
		_svc.util.clear("#solubilityQuizComponent");
		_svc.util.clear("#solubilityQuizScoresComponent");
		_svc.util.clear("#nomenclatureQuizComponent");
		_svc.util.clear("#nomenclatureQuizScoresComponent");
		_svc.util.clear("#elementsComponent");
		_svc.util.clear("#visitorsComponent");
    }

}
setTimeout(function(){
    _cmp.main = new MainComponent();
    _cmp.main.render();
}, 200);